import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { HiClipboardDocumentList } from 'shared/HarmonyIcon'

const useStyles = makeStyles((theme: Theme) => ({
    btn: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: pxToRem(24),
        height: pxToRem(24),
        border: 'none',
        background: 'transparent',
        borderRadius: 2,
        padding: theme.spacing(0.5),
        '&:hover': {
            background: '#EEEEEE',
            borderRadius: '2px',
            transition: 'all 0.2s ease-in-out',
        },
    },
}))

interface TaskIndicatorButtonProps {
    onClick?: () => void
    style?: React.CSSProperties
    className?: string
}

const TaskIndicatorButton = ({ onClick, style, className }: TaskIndicatorButtonProps) => {
    const classes = useStyles()
    return (
        <button
            type="button"
            aria-label="Open project tasks"
            className={`${classes.btn}${className ? ` ${className}` : ''}`}
            style={style}
            onClick={onClick}
        >
            <HiClipboardDocumentList size={14} color="#4C92D9" />
        </button>
    )
}

export default TaskIndicatorButton
